import styled from "styled-components";

export const StyledTileParent = styled.div`
  margin: 0.5rem;
`;
